import React from "react";
import { useNavigate } from "react-router-dom";
import "./GameScheduleCard.css";

const GameScheduleCard = ({ game }) => {
  const navigate = useNavigate();
  const isOpen = game.msg_status === 1;
const getMarketResult = () => {
  const open = game.open_result?.trim();
  const close = game.close_result?.trim();

  if (open && close) return `${open}${close}`;
  if (open && !close) return `${open}*-***`;
  return `***-**-***`;
};
  // Function to handle calendar icon click
  const handleCalendarClick = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    
    if (game.panel_chart_url) {
      // Navigate to chart page with the URL
      navigate('/chart', { 
        state: { 
          chartUrl: game.panel_chart_url,
          gameName: game.game_name 
        }
      });
    } else {
      console.log("No panel chart URL available for", game.game_name);
      alert("Chart not available for this game");
    }
  };

  // Function to handle Play Now click
  const handlePlayClick = () => {
    if (isOpen) {
      // Navigate to game types page
      navigate('/game-types', { 
        state: { 
          gameData: game 
        }
      });
    }
  };

  return (
    <div className="market-card">
      <div className="market-header">
        <h3>{game.game_name}</h3>
        <span 
          className="calendar-icon" 
          onClick={handleCalendarClick}
          style={{ cursor: 'pointer' }}
          title="View Chart"
        >
          📅
        </span>
      </div>

<div className="market-stars">
  {getMarketResult()}
</div>
      <div className="market-time">
        <div>
          <span>Time Open:</span>
          <strong>{game.open_time}</strong>
        </div>
        <div>
          <span>Time Close:</span>
          <strong>{game.close_time}</strong>
        </div>
      </div>

      {isOpen ? (
        <button className="play-btn" onClick={handlePlayClick}>
          <span>▶</span> Play Now
        </button>
      ) : (
        <div className="closed-text">Closed For Today</div>
      )}
    </div>
  );
};

export default GameScheduleCard;